import axios from "../../axiosInstance";

export const deleteBadge = async (id: string): Promise<void> => {
  await axios.delete(`/api/badges/${id}`);
};

export default deleteBadge;
